export default __webpack_public_path__ + "static/media/TeacherLearningCenterPicturev3.5b9b366b.png";